import contextualVoucher from "../../../assets/images/projects/contextual-voucher/thumbnail.png";
import { ProjectDataProps } from "../props";

export default {
  title: "Contextual Voucher",
  description:
    "Design thinking storytelling on how we tackle promo painpoints in purchasing",
  image: contextualVoucher,
  path: "/contextual-voucher",
} as ProjectDataProps;
